import React from 'react';

interface ContactSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

const ContactSuccessModal: React.FC<ContactSuccessModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div className="bg-card border-secondary/30 relative w-full max-w-md rounded-2xl border-2 p-8 text-center">
        {/* Success Icon */}
        <div className="from-secondary to-primary mx-auto mb-6 h-20 w-20 rounded-full bg-gradient-to-r p-1">
          <div className="bg-card flex h-full w-full items-center justify-center rounded-full">
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth="3"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-bgColor h-10 w-10"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
        </div>

        {/* Heading */}
        <h2 className="text-foreground mb-4 text-2xl font-bold">{title}</h2>

        {/* Message */}
        <p className="text-muted-foreground mb-8 leading-relaxed">{message}</p>

        {/* Close Button */}
        <button
          onClick={onClose}
          aria-label="Close success message"
          className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-6 py-3 font-medium transition-all"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ContactSuccessModal;
